import { IMAGES } from "../data";
import { Trees, Scissors, Layers, Leaf } from "lucide-react";

const services = [
  {
    id: "design",
    testid: "service-card-design",
    title: "Landscape Design",
    desc: "Custom outdoor concepts — garden beds, plantings, and curated layouts that bring your property to life.",
    img: IMAGES.design,
    icon: Trees,
    className: "md:col-span-2 md:row-span-2",
    big: true,
  },
  {
    id: "maintenance",
    testid: "service-card-maintenance",
    title: "Lawn & Garden Maintenance",
    desc: "Mowing, edging, pruning and fertilization to keep your lawn pristine all season.",
    img: IMAGES.maintenance,
    icon: Scissors,
    className: "md:col-span-2",
  },
  {
    id: "hardscape",
    testid: "service-card-hardscape",
    title: "Irrigation, Patios & Stone Walls",
    desc: "Durable hardscaping — paver patios, walkways, retaining walls and efficient irrigation systems.",
    img: IMAGES.hardscape,
    icon: Layers,
    className: "md:col-span-1",
  },
  {
    id: "cleanup",
    testid: "service-card-cleanup",
    title: "Leaf & Seasonal Cleanup",
    desc: "Thorough seasonal clearing — leaf removal, bed refresh and storm prep.",
    img: IMAGES.cleanup,
    icon: Leaf,
    className: "md:col-span-1",
  },
];

const Card = ({ s }) => {
  const Icon = s.icon;
  return (
    <article
      data-testid={s.testid}
      className={`group relative overflow-hidden rounded-sm border border-[#D8D3C8] bg-[#EFECE4] min-h-[240px] ${s.className} transition-all duration-500 hover:-translate-y-1`}
    >
      <img
        src={s.img}
        alt={s.title}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#13210F]/90 via-[#13210F]/35 to-transparent" />
      <div className="relative z-10 h-full flex flex-col justify-end p-6 md:p-8">
        <Icon size={s.big ? 30 : 24} strokeWidth={1.5} className="text-[#C7D6B8] mb-3" />
        <h3 className={`font-serif-display text-white ${s.big ? "text-3xl md:text-4xl" : "text-2xl"} leading-snug`}>
          {s.title}
        </h3>
        <p className="text-white/80 text-sm font-light mt-2 max-w-md leading-relaxed">{s.desc}</p>
      </div>
    </article>
  );
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <p className="overline">What We Do</p>
          <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight leading-tight mt-4 text-[#1A2118]">
            Full-service care for every corner of your landscape
          </h2>
        </div>

        <div data-testid="services-grid" className="grid grid-cols-1 md:grid-cols-4 gap-5 mt-14 auto-rows-[240px]">
          {services.map((s) => (
            <Card key={s.id} s={s} />
          ))}
        </div>
      </div>
    </section>
  );
};
